export enum PlayResult {
  Block =  'Block',
  BlockDefTD =  'Block, Def TD',
  Complete =  'Complete',
  CompleteFumble =  'Complete, Fumble',
  CompleteTD =  'Complete, TD',
  NoGoodDefTD =  'No Good, Def TD',
  Fumble =  'Fumble',
  FumbleDefTD =  'Fumble, Def TD',
  Good =  'Good',
  Incomplete =  'Incomplete',
  IncompleteBattedDown =  'Batted Down',
  Interception = 'Interception',
  InterceptionDefTD =  'Interception, Def TD',
  InterceptionFumble =  'Interception, Fumble',
  InterceptionSafety =  'Interception, Safety',
  NoGood =  'No Good',
  Sack =  'Sack',
  Penalty =  'Penalty',
  OnsideKickHomeTD =  'Onside Kick, Home TD',
  OnsideKickAwayTD =  'Onside Kick, Away TD',
  PenaltySafety =  'Penalty, Safety',
  NoPlay =  'No Play',
  Recovered =  'Recovered',
  Return =  'Return',
  Simple =  'Simple',
  Rush =  'Rush',
  RushSafety =  'Rush, Safety',
  RushTD =  'Rush, TD',
  SackFumble =  'Sack, Fumble',
  SackFumbleDefTD =  'Sack, Fumble, Def TD',
  SackSafety =  'Sack, Safety',
  Safety =  'Safety',
  SafetyReceivingTeam =  'Safety Receiving Team',
  TD =  'TD',
  Timeout =  'Timeout',  //On l'utilisera pas
  TouchBack =  'TouchBack',  //On l'utilisera pas
  DeadBall =  '',  //Utilisé pour les DeadBall, n'existe pas dans hudl.
  TeamLost =  'TeamLost', //Bad Snap, Ne pas donner de stats à cause d'un mauvais snap.
  Missing =  'MissingPlayResult', //Missing PlayResult
}

//Jeux ou le traitement des commands final est différents et ne requiert pas IncreaseDownCommand, CalculateDistanceCommand, CalculateYardLineCommand, ApplyDownRulesCommand
export const exceptionResultList = [
  PlayResult.RushSafety,
  PlayResult.SackSafety,
  PlayResult.PenaltySafety,
  PlayResult.Safety,
  PlayResult.Return,
  PlayResult.SafetyReceivingTeam,
  PlayResult.Block,
  PlayResult.BlockDefTD,
  PlayResult.Good,
  PlayResult.NoGood,
  PlayResult.Fumble,
  PlayResult.FumbleDefTD,
  PlayResult.SackFumbleDefTD,
  PlayResult.SackFumble,
  PlayResult.Penalty,
  PlayResult.Simple,
  PlayResult.DeadBall, //Sifflet Estempestif, Ballon touche les poteaux zonne de but, Ballon sort du EndZone sur KickOff, etc...
  PlayResult.Recovered,
  PlayResult.InterceptionSafety,
  PlayResult.Interception,
  PlayResult.Missing
]
